const AuthQueryFactory = {
    session: () => ['auth', 'user-session'],
    systemStates: () => ['auth', 'system-states'],
    userAgencies: () => ['auth', 'user-agencies'],
};

export { AuthQueryFactory };
